import { IUserInfo } from "../models/Users";
export const excelDateToJSDate = (serial: number) => {
  if (!serial) return "";
  const utc_days = Math.floor(serial - 25569);
  const utc_value = utc_days * 86400;
  const date_info = new Date(utc_value * 1000);
  return date_info.toISOString().split("T")[0];
};
export const canEditTimesheet = (userInfo: IUserInfo | null): boolean => {
  if (!userInfo) return false;

  if (userInfo.role === "ADMIN" || userInfo.role === "SUPER_ADMIN") {
    return true;
  }

  if (userInfo.position?.level === "MANAGER") {
    return true;
  }

  return false;
};
export const formatFileSize = (bytes: number) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
};
